// /*
//  * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
//  */
import i18n from 'i18next';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';

/**
* The replaceLast utility replaces the last occurrence of a substring
* with a replacement string.
*
* ```typescript
*
*   import {replaceLast} from 'core/utils/helpers';
*
*   expect(replaceLast('/a/b/c', '/', '-')).to.equal('/a/b-c'); // true
 *
 * ```
*/
export const replaceLast = (value: string, search: string, replacement: string): string => {
  const chars = value.split('');
  const index = value.lastIndexOf(search);
  if (index > -1) {
    const n = index + search.length;
    for (let i = index; i < n; i++) {
      if (i === index) {
        chars[i] = replacement;
      } else {
        delete chars[i];
      }
    }
  }
  return chars.join('');
};

/**
*
*
* Basic utility which provides general formatting of rule requirements,
* padding commas, and replacing the last comma with 'and' or 'or'.
*/
export const formatRequirements = (rules: string[], includes: boolean = true) => {
  const values = rules.toString().replace(/,/g, ', ');
  const replacement = ` ${translate(`common:conjunctions.${includes ? 'and' : 'or'}`)} `;
  return replaceLast(values, ',', replacement).replace(/\s\s+/g, ' ');
};
